// extracted by mini-css-extract-plugin
export default {"Modal":"RegularModal_Modal__ODpUA"};